import React, { useEffect, useRef } from 'react';
import {Form, Button, Checkbox, Typography, Spin} from "antd"
import FormField from './sub-components/FormField';
import { FORM_FIELDS, FORM_TEXTS } from '../helpers/misc';
import App from '../../app/App';

const { Title} = Typography;

const RegistrationForm = ({ 
  formData, 
  formErrors,
  verificationStatus,
  onFormChange, 
  onSubmit,
  scrollToField,
  onScrollComplete,
  loading
}) => {
  const toastShownRef = useRef(false);


  useEffect(() => {
    if (scrollToField) {
      const element = document.getElementById(scrollToField);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        onScrollComplete();
      }
    }
  }, [scrollToField, onScrollComplete]);

  // Show message for new card assignment
  useEffect(() => {
    if (verificationStatus === "new" && !toastShownRef.current) {
      App.$toast(FORM_TEXTS.newCardMessage);
      toastShownRef.current = true;
    }
  }, [verificationStatus]);


  const handleFieldChange = (field, value) => {
    onFormChange(field, value);
  };

  const handleCheckboxChange = (e) => {
    onFormChange('terms_accepted', e.target.checked);
  }

  return (
      <Form
        layout="vertical"
        onFinish={onSubmit}>
        {FORM_FIELDS.map(field => (
          <FormField /*MA: SPATNA, FAKT SPATNA KOMOPONENTKA, DELA NAM BORDEL VE ZBYTKU KODU. NEVYZNAM SE V TOM. UVNITR JE STEJNE CASE KE KAZDYMU INPUT LOL, LOL*/
            key={field.name}
            field={field}
            formData={formData}
            formErrors={formErrors}
            defaultValue={(field.name === "country") ? "sk" : null}
            onFieldChange={handleFieldChange}
          />
        ))}
        
        <Form.Item
          id="terms_accepted"
          name="terms_accepted"
          valuePropName="checked"
          validateStatus={formErrors.terms_accepted ? 'error' : ''}
          help={formErrors.terms_accepted}
          style={{padding: "2em 0"}}
          required
        >
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <Checkbox 
              checked={formData.terms_accepted}
              onChange={handleCheckboxChange}
              style={{ marginTop: '4px' }}
            />
            <span style={{ marginLeft: '8px', lineHeight: '1.5', textAlign: 'left' }}>
              {FORM_TEXTS.termsBusinessPrefix}

              <a href="https://www.benulekaren.sk/data/images/_orig/4/2_181164.pdf"
                style={{cursor: 'pointer' }}>{FORM_TEXTS.termsBusinessLink}</a>

              {FORM_TEXTS.termsBusinessSuffix}

              <a href="/files/gdpr_web_karta.pdf"
                 style={{cursor: 'pointer' }}>{FORM_TEXTS.termsPrivacyLink}</a>

              {FORM_TEXTS.termsPrivacySuffix}*

            </span>
          </div>
        </Form.Item>
        <Spin spinning={loading}>
          <Button
            type="primary"
            className="ant-submit"
            htmlType="submit"
          >
            {verificationStatus === "new" ? FORM_TEXTS.submitButtonNew : FORM_TEXTS.submitButtonUpdate}
        </Button>
        </Spin>
      </Form>
  );
};

export default RegistrationForm;
